export const QA_NAME_EMAIL_THEME_VIEW_BUTTON = 'emailThemeViewButton'

export const RE_WS = /[ \t\r\n\f]/g

export const RE_WS_NBSP = /[ \t\r\n\f\u00A0]/g

export const RE_ZWS = /[\u200B-\u200D\uFEFF]/g

export const RE_SEPARATOR = /^\s*[-—_*]{5,}\s*$/

export const RE_TIME = /\b(?:[01]?\d|2[0-3]):[0-5]\d\b/

export const RE_EMAIL_ANGLE = /(?:&lt;|<)[^>]+@[^>]+\.[^>]+(?:&gt;|>)/

export const RE_EMAIL_PLAIN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i

export const RE_YEAR = /\b\d{4}\b/

export const RE_BODY = /<body[^>]*>([\s\S]*?)<\/body>/i

export const RE_BODY_TAG = /<body\b([^>]*)>/i

export const RE_BODY_BGCOLOR_ATTR = /\bbgcolor\s*=\s*["']?([^"'\s>]+)/i

export const RE_BODY_STYLE_ATTR = /\bstyle\s*=\s*(?:"([^"]*)"|'([^']*)')/i

export const RE_STYLE_BACKGROUND =
  /(?:^|;)\s*background(?:-color)?\s*:\s*([^;]+)/i

export const RE_STYLE_COLOR = /(?:^|;)\s*color\s*:\s*([^;]+)/i

export const RE_STYLE_COLOR_DECLARATION = /(^|;)\s*color\s*:[^;]*/gi

export const RE_SAFE_COLOR =
  /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\)|hsla?\([\d\s.,%deg]+\)|[a-z]+)$/i

export const RE_HEX_COLOR = /^#([0-9a-f]{3,8})$/i

export const RE_RGB_COLOR =
  /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/i

// Zero-alpha colors render fully transparent regardless of their channels.
export const RE_ZERO_ALPHA_COLOR =
  /^(?:(?:rgba|hsla)\([^)]+,\s*(?:0(?:\.0+)?|\.0+)%?\s*\)|#[0-9a-f]{3}0|#[0-9a-f]{6}00)$/i

// Emails commonly declare colors as `color: white !important`.
export const RE_IMPORTANT_SUFFIX = /\s*!\s*important\s*$/i

export const WHITE_RGB = [255, 255, 255]

/**
 * Minimum WCAG contrast ratio between an inline text color and its effective
 * background — anything below is treated as unreadable and the inline color
 * is dropped so the text falls back to the default color.
 */
export const EMAIL_TEXT_MIN_CONTRAST_RATIO = 1.5

// Only the colors we must be able to "see through" by name: light ones (to
// catch light-on-light text) and the basic palette senders use for
// backgrounds and text. Unknown names stay unparsed → the color is kept.
export const NAMED_COLORS_RGB = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  black: [0, 0, 0],
  blue: [0, 0, 255],
  brown: [165, 42, 42],
  cornsilk: [255, 248, 220],
  cyan: [0, 255, 255],
  floralwhite: [255, 250, 240],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  ivory: [255, 255, 240],
  lavenderblush: [255, 240, 245],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgrey: [211, 211, 211],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mintcream: [245, 255, 250],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  orange: [255, 165, 0],
  pink: [255, 192, 203],
  purple: [128, 0, 128],
  red: [255, 0, 0],
  seashell: [255, 245, 238],
  silver: [192, 192, 192],
  snow: [255, 250, 250],
  teal: [0, 128, 128],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
}

// Background values that are not colors — the node shows whatever is behind.
export const SEE_THROUGH_BACKGROUNDS = [
  'transparent',
  'none',
  'inherit',
  'initial',
  'unset',
]
